import { useState, useEffect } from "react";
import InputData from "./InputData";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Tag from "./Tag";
import CheckBox from "./CheckBox";
import { post } from "../js/post";
import { userData, familiesList } from "../js/utils";

export function DashboardPatientPanelPurchaseFilterSection({
  onChange,
  status = null,
  onClick = null,
}) {
  const [selectedFamiliesList, setSelectedFamiliesList] = useState([]);
  const [selectedFamiliesIdList, setSelectedFamiliesIdList] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [selectedSuppliersList, setSelectedSuppliersList] = useState([]);
  const [selectedSuppliersIdList, setSelectedSuppliersIdList] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [selectedBrandsList, setSelectedBrandsList] = useState([]);
  const [purchaseDate, setPurchaseDate] = useState({ from: "", to: "" });
  const [purchaseVolume, setPurchaseVolume] = useState({ from: "", to: "" });
  const [availablePoints, setAvailablePoints] = useState({ from: "", to: "" });
  const [toggle, setToggle] = useState({
    lastPurchase: false,
    excludedReturned: false,
    withLoyalty: false,
    withoutLoyalty: false,
  });

  async function getPurchaseSuppliersAndBrands() {
    const response = await post(
      "support-extra/dashboard/ListarProveedoresMarcasCompras.php",
      {
        token: userData.token,
        familias: selectedFamiliesIdList,
      },
    );
    setSuppliersList(response);
    const brands = response.flatMap((e) => e.marcas);
    setBrandsList([...new Set(brands)].sort());
  }

  function resetFilters() {
    setSelectedFamiliesList([]);
    setSelectedSuppliersList([]);
    setSelectedBrandsList([]);
    setPurchaseDate({ from: "", to: "" });
    setPurchaseVolume({ from: "", to: "" });
    setAvailablePoints({ from: "", to: "" });
    setToggle({
      lastPurchase: false,
      excludedReturned: false,
      withLoyalty: false,
      withoutLoyalty: false,
    });
  }

  useEffect(() => {
    setSelectedSuppliersList(
      selectedSuppliersList.filter((e) =>
        suppliersList.some((supplier) => supplier.nombre === e),
      ),
    );
  }, [suppliersList]);

  useEffect(() => {
    setSelectedBrandsList(
      selectedBrandsList.filter((e) => brandsList.includes(e)),
    );
  }, [brandsList]);

  useEffect(() => {
    setSelectedFamiliesIdList(
      familiesList
        .filter((e) => selectedFamiliesList.includes(e.text))
        .map((e) => e.id),
    );
  }, [selectedFamiliesList]);

  useEffect(() => {
    setSelectedSuppliersIdList(
      suppliersList
        .filter((e) => selectedSuppliersList.includes(e.nombre))
        .map((e) => e.id),
    );
  }, [selectedSuppliersList]);

  useEffect(() => {
    if (selectedSuppliersList.length === 0) setSelectedBrandsList([]);
  }, [selectedSuppliersList]);

  useEffect(() => {
    const brands = suppliersList
      .filter((e) => selectedSuppliersIdList.includes(e.id))
      .flatMap((e) => e.marcas);
    setBrandsList([...new Set(brands)].sort());
  }, [selectedSuppliersIdList]);

  useEffect(() => {
    onChange({
      familia: selectedFamiliesIdList,
      proveedores: selectedSuppliersIdList,
      marcas: selectedBrandsList,
      fechaCompraDesde: purchaseDate.from,
      fechaCompraHasta: purchaseDate.to,
      seaUltimaCompra: toggle.lastPurchase,
      volumenCompraDesde: purchaseVolume.from,
      volumenCompraHasta: purchaseVolume.to,
      noIncluirComprasDevueltas: toggle.excludedReturned,
      puntosDisponiblesDesde: availablePoints.from,
      puntosDisponiblesHasta: availablePoints.to,
      conFidelizacion: toggle.withLoyalty,
      sinFidelizacion: toggle.withoutLoyalty,
    });
  }, [
    selectedFamiliesIdList,
    selectedSuppliersIdList,
    selectedBrandsList,
    purchaseDate,
    purchaseVolume,
    availablePoints,
    toggle,
  ]);

  useEffect(() => {
    getPurchaseSuppliersAndBrands();
  }, [selectedFamiliesIdList]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div
          className="opt-table-title opt-table-title-dash-stats"
          style={{ justifyContent: "flex-start" }}
        >
          Filtros de compra
          {status !== null && (
            <button className="cell-icon" onClick={onClick}>
              <img
                src={
                  status
                    ? "/images/arrow-up-blue.svg"
                    : "/images/arrow-down-blue.svg"
                }
                loading="lazy"
                alt="Icon"
                className="cell-icon"
              ></img>
            </button>
          )}
        </div>
        <button
          className="cell-label"
          tabIndex={-1}
          style={{ width: "120px" }}
          onClick={resetFilters}
        >
          Limpiar filtros
        </button>
      </div>

      <div className="store-row-sec">
        <div className="store-col-sec" style={{ flex: 1 }}>
          <div className="data-field">
            <span className="label">Familia</span>
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={84}
              type={"type-alphanum-ext"}
              options={familiesList.map((e) => e.text)}
              selectedOptions={selectedFamiliesList}
              onChange={(e) => {
                setSelectedFamiliesList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          {selectedFamiliesList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Familias seleccionadas: {selectedFamiliesList.length}
            </span>
          )}
          <div className="tag-content">
            {selectedFamiliesList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedFamiliesList((prev) =>
                      prev.filter((element) => element !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
        </div>
        <div className="store-col-sec" style={{ flex: 1 }}>
          <div className="data-field">
            <span className="label">Proveedor</span>
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={85}
              inactive={selectedFamiliesIdList.length === 0}
              type={"type-alphanum-ext"}
              options={suppliersList.map((e) => e.nombre)}
              selectedOptions={selectedSuppliersList}
              onChange={(e) => {
                setSelectedSuppliersList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          {selectedSuppliersList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Proveedores seleccionados: {selectedSuppliersList.length}
            </span>
          )}
          <div className="tag-content">
            {selectedSuppliersList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedSuppliersList((prev) =>
                      prev.filter((element) => element !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
        </div>
        <div className="store-col-sec" style={{ flex: 1 }}>
          <div className="data-field">
            <span className="label">Marca</span>
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={86}
              type={"type-alphanum-ext"}
              inactive={selectedSuppliersList.length === 0}
              options={brandsList}
              selectedOptions={selectedBrandsList}
              onChange={(e) => {
                setSelectedBrandsList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          {selectedBrandsList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Marcas seleccionadas: {selectedBrandsList.length}
            </span>
          )}
          <div className="tag-content">
            {selectedBrandsList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedBrandsList((prev) =>
                      prev.filter((element) => element !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
        </div>
      </div>

      <div className="opt-table-content grid-11" id="patient-purchase-filters">
        <div className="cell cell-start-content">Fecha compra desde</div>
        <div className="cell">
          <InputData
            type="date"
            max="9999-12-31"
            size={0}
            tabIndex={87}
            input={purchaseDate.from}
            onChange={(e) => {
              setPurchaseDate((prev) => ({
                ...prev,
                from: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Volumen de compra desde</div>
        <div className="cell">
          <InputData
            type="type-float2"
            size={0}
            tabIndex={89}
            input={purchaseVolume.from}
            onChange={(e) => {
              setPurchaseVolume((prev) => ({
                ...prev,
                from: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell  cell-start-content combined-cells-3">
          Puntos disponibles desde
        </div>
        <div className="cell combined-cells-2">
          <InputData
            type="type-integer"
            size={0}
            tabIndex={91}
            input={availablePoints.from}
            onChange={(e) => {
              setAvailablePoints((prev) => ({
                ...prev,
                from: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell cell-start-content">Fecha compra hasta</div>
        <div className="cell">
          <InputData
            type="date"
            max="9999-12-31"
            size={0}
            tabIndex={88}
            input={purchaseDate.to}
            onChange={(e) => {
              setPurchaseDate((prev) => ({
                ...prev,
                to: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Volumen de compra hasta</div>
        <div className="cell">
          <InputData
            type="type-float2"
            size={0}
            tabIndex={90}
            input={purchaseVolume.to}
            onChange={(e) => {
              setPurchaseVolume((prev) => ({
                ...prev,
                to: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell  cell-start-content combined-cells-3">
          Puntos disponibles hasta
        </div>
        <div className="cell combined-cells-2">
          <InputData
            type="type-integer"
            size={0}
            tabIndex={92}
            input={availablePoints.to}
            onChange={(e) => {
              setAvailablePoints((prev) => ({
                ...prev,
                to: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell cell-start-content">Sea última compra</div>
        <div className="cell cell-start-content">
          <CheckBox
            tabIndex={93}
            active={toggle.lastPurchase}
            onClick={() => {
              setToggle((prev) => ({
                ...prev,
                lastPurchase: !toggle.lastPurchase,
              }));
            }}
          ></CheckBox>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          No incluir compras devueltas
        </div>
        <div className="cell cell-start-content">
          <CheckBox
            tabIndex={94}
            active={toggle.excludedReturned}
            onClick={() => {
              setToggle((prev) => ({
                ...prev,
                excludedReturned: !toggle.excludedReturned,
              }));
            }}
          ></CheckBox>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Con fidelización</div>
        <div className="cell">
          <CheckBox
            tabIndex={95}
            active={toggle.withLoyalty}
            onClick={() => {
              setToggle((prev) => ({
                ...prev,
                withLoyalty: !toggle.withLoyalty,
                withoutLoyalty: false,
              }));
            }}
          ></CheckBox>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Sin fidelización</div>
        <div className="cell">
          <CheckBox
            tabIndex={96}
            active={toggle.withoutLoyalty}
            onClick={() => {
              setToggle((prev) => ({
                ...prev,
                withoutLoyalty: !toggle.withoutLoyalty,
                withLoyalty: false,
              }));
            }}
          ></CheckBox>
        </div>
      </div>
    </div>
  );
}
